import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={18}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m8.541.372-3.15 2.302-.83.606H.754a.595.595 0 0 0-.595.594V8.18c0 .328.267.594.595.594H4.56l.83.607 3.151 2.301c.265.193.48.084.48-.243V.615c0-.327-.215-.436-.48-.243ZM12.521 9a.52.52 0 0 1-.368-.89l4.957-4.957a.522.522 0 1 1 .737.737L12.89 8.847a.52.52 0 0 1-.369.153Zm4.957 0a.52.52 0 0 1-.368-.153L12.153 3.89a.522.522 0 0 1 .737-.737l4.957 4.957a.522.522 0 0 1-.369.89Z"
      fill="var(--theme-background)"
      opacity={1}
    />
  </svg>
);

export default SvgComponent;
